module.exports = __webpack_public_path__ + "static/media/homepage_commerce.7d600033.mp4";